import AllowedDimensions from "./AllowedDimensions";
import CompressedGeometry from "./CompressedGeometry";
import Leg from "./Leg";

export default class Itinerary {
    public computationType: string;
    public totalLength: number;
    public totalDuration: number;
    public allowedDimensions: AllowedDimensions;
    public tideDependent: boolean;
    public numberOfLocks: number;
    public geometry: CompressedGeometry;
    public legs: Leg[];

    public constructor(data: any) {
        if (!data) {
            return;
        }
        this.computationType = data.ComputationType;
        this.totalLength = data.TotalLength;
        this.totalDuration = data.TotalDuration;
        this.allowedDimensions = new AllowedDimensions(data.AllowedDimensions);
        this.tideDependent = data.TideDependent ? true : false;
        this.numberOfLocks = data.NumberOfLocks;
        this.geometry = data.Geometry;
        this.legs = [];
        if (data.Legs && data.Legs.length) {
            data.Legs.forEach((l: any) => this.legs.push(new Leg(l)));
        }
    }
}